module.exports = __webpack_public_path__ + "static/media/toronto_logo.d5a245c9.jpg";